import { render, staticRenderFns } from "./cardsListWrapper.vue?vue&type=template&id=29389ac8&"
import script from "./cardsListWrapper.vue?vue&type=script&lang=js&"
export * from "./cardsListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./cardsListWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports